import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL: /zh-cn/whitepapers/<slug> moved to /zh-cn/downloads/<slug>.
// Thrown from beforeLoad so SSR answers with a real HTTP redirect.
export const Route = createFileRoute("/zh-cn/whitepapers/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/zh-cn/downloads/$slug",
      params: { slug: params.slug },
      replace: true,
      statusCode: 301,
    });
  },
});
